import { clientApi } from 'api';
import { IHomeProduct } from 'server/models/HomeProducts/types';

export const getHomeProducts = (isServer = false) => async () => {
  const response = await clientApi.get<IHomeProduct[]>('/home-products');

  return response;
};
